import { cn } from "@/lib/utils";

/**
 * Dinnobot — the robot mascot for the in-app help assistant.
 *
 * Renders the real transparent PNG art. Two framings:
 *  - ``variant="full"`` (default) → the whole standing robot (`/guide-bot.png`),
 *    for the big floating launcher; floats with a shape drop-shadow.
 *  - ``variant="avatar"`` → the front-facing head/bust (`/dinnox-avatar.png`),
 *    for the small round in-chat avatars + the top-bar toggle, where a full body
 *    would shrink to an unreadable blob. It looks straight at the user (open
 *    eyes), so it reads as a face at avatar sizes.
 *
 * The white robot has strong contrast on both light and dark backgrounds, so one
 * asset serves both themes. Kept named `DinnoxBot` so call sites are unchanged.
 * To swap brand art later, replace the PNGs in `frontend/public/` (same names).
 */
export function DinnoxBot({
  className,
  title,
  variant = "full",
}: {
  className?: string;
  /** Accessible name; omit for a decorative avatar (empty alt). */
  title?: string;
  variant?: "full" | "avatar";
}) {
  return (
    <img
      src={variant === "avatar" ? "/dinnox-avatar.png" : "/guide-bot.png"}
      alt={title ?? ""}
      draggable={false}
      className={cn("select-none object-contain", className)}
    />
  );
}
